import request from "@/utils/request";

/**
 * 登录/注册相关 API
 */

/**
 * 发送邮箱验证码（后端发邮件可能较慢，依赖全局请求超时）
 * @param {string} email 邮箱地址
 * @returns {Promise}
 */
export function sendEmailCode(email) {
  return request.post("/api/sendEmailCode", { email: email });
}

/**
 * 邮箱密码登录
 * @param {string} email 邮箱地址
 * @param {string} password 密码
 * @param {string} captcha 验证码
 * @param {string} captchaKey 验证码key
 * @returns {Promise}
 */
export function loginByEmail(email, password, captcha, captchaKey) {
  return request.post("/api/loginByEmail", {
    email: email,
    password: password,
    captcha: captcha,
    captchaKey: captchaKey,
  });
}

/**
 * 邮箱验证码注册
 * @param {string} email 邮箱地址
 * @param {string} code 验证码
 * @param {string} password 密码
 * @returns {Promise}
 */
export function register(email, code, password) {
  return request.post("/api/register", {
    email: email,
    code: code,
    password: password,
  });
}

/**
 * 忘记密码：邮箱验证码重置密码
 */
export function resetPassword(email, code, password) {
  return request.post("/api/resetPassword", { email, code, password });
}

/**
 * 获取第三方登录授权地址
 * @param {string} oauthType 第三方类型：GITEE, QQ
 * @returns {Promise}
 */
export function getOauthAuthUrl(oauthType) {
  return request.get(`/api/oauth/render/${oauthType}`);
}

/**
 * 第三方登录
 * @param {string} code 授权码
 * @param {string} oauthType 第三方类型：GITEE, QQ
 * @param {string} state state 参数
 * @param {string} email 可选，邮箱地址（用于绑定）
 * @returns {Promise}
 */
export function oauthLogin(code, oauthType, state, email) {
  return request.post("/api/oauth/login", {
    code: code,
    oauthType: oauthType,
    state: state || "",
    email: email || "",
  });
}
